import React from 'react';

import Radium from 'radium';
import ReactTable from 'react-table'
import SessionStore from 'stores/SessionStore';

import DateComponent from 'views/DateComponent';

import AppConstants from 'AppConstants';
import AppUtil from 'AppUtil';
import {A, Button} from 'views/AppElements';
import ChangeOrderStateModalForm from 'views/admin/ChangeOrderStateModalForm';

import PaymentInfo from 'views/order/PaymentInfo';
import PhotoFrameImg from 'views/order/PhotoFrameImg';

const ORDER_STATE = AppConstants.ORDER_STATE;
const DELIVERY_LOCATION_TYPE = AppConstants.DELIVERY_LOCATION_TYPE;

const OrderSubComponent = (row) => {
	const order = row.original;

	let orderPremise = "";

	if(order.locationType && order.locationType === DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY.val)
		orderPremise = <b style={{color: 'rgb(248, 147, 18)'}}>{DELIVERY_LOCATION_TYPE.OUTSIDE_KTM_VALLEY.label} - </b>;
	else if (order.locationType && order.locationType === DELIVERY_LOCATION_TYPE.OUTSIDE_RING_ROAD.val)
		orderPremise = <b>{DELIVERY_LOCATION_TYPE.OUTSIDE_RING_ROAD.label} - </b>;

	const discountAmount = order.discountAmount? (order.discountAmount * order.quantity) : null;
	
	const orderMetaData = order.orderMetaData || {};
	
	const metaDataList = Object.keys(orderMetaData).map(k => {
		const valueString = orderMetaData[k] instanceof Object? JSON.stringify(orderMetaData[k]): orderMetaData[k].toString();
		return <span key={order.orderId+"_"+k}><b>{k.toUpperCase()}</b> {": " + valueString}</span>;
	});

	const isCustomPhotoFrame = AppUtil.isCustomProduct(order.product) 
							&& order.product.productType === AppConstants.PRODUCT_TYPES['PHOTO_FRAME'].val;

	return <div style={{display: 'flex', flexDirection: 'row', padding: '15px', background: 'white'}}>
				{
					isCustomPhotoFrame &&
					//TODO: later show this for all frames
					<PhotoFrameImg id={"order"+order.orderId+"Img"} imgUrl={order.orderedProductImage}
                                                    matting={orderMetaData['matting']} 
													borderColor={orderMetaData['borderColor']} />
				}
				{
					!isCustomPhotoFrame &&
					<img src={order.orderedProductImage} style={{height: '200px'}} alt={"Ordered Image "+order.orderId} />
				}

				<div style={{padding: '0 10px 10px 10px', marginLeft: '50px', color: '#7b7979'}}>
					<h2 style={{color: 'gray', margin: '0 10px 15px 0'}}>
						<i className="fa fa-address-card-o" aria-hidden="true"></i> Delivery Detail
					</h2>

					{order.deliveryType === AppConstants.DELIVERY_TYPE.IMMEDIATE.val &&
						<h4 style={{color: '#f89312'}}><b>Immediate Delivery within next 24 hours!</b></h4>
					}

					<h4><i className="fa fa-phone-square" aria-hidden="true"></i> Contact Number: <b style={{color: 'black'}}>{order.phone}</b></h4>
				 	<h4><i className="fa fa-street-view" aria-hidden="true"></i> Address: {orderPremise} <b style={{color: 'black'}}>{order.streetAddress}</b></h4>
				 	{
				 		order.additionalNote &&	
				 		<p style={{whiteSpace: 'pre-line'}}>- {order.additionalNote}</p>
				 	}

					 {order.paymentPreference && order.paymentPreference !== 'COD' &&
					 	<p style={{whiteSpace: 'pre-line'}}>Preferred Payment via {order.paymentPreference}</p>
					 }

					{
						discountAmount &&
						<h4 style={{color: 'green', margin: '0'}}>- <i className="fa fa-tags" aria-hidden="true"></i> Discount Received Rs. {discountAmount}</h4>
					}
					{
						metaDataList &&
						<div className="flexColumn orderMetaDataInfo">{metaDataList}</div>
					}
				</div>
			</div>;
};


class OrdersList extends React.Component {

	constructor(props) {
		super(props);
		this.handleCloseOrderModalClose = this.handleCloseOrderModalClose.bind(this);

		this.state = {toUpdateOrder: null};
	}

	getOrderInfoColumn() {
		const userType = SessionStore.getCurrentSession()? SessionStore.getCurrentSession().user.userType: null;
		const orderInfo = [{Header: 'Id', accessor: 'orderId', width: 60, filterable: true,
								Cell: function(props) {
									const hasSalesPermission = userType === AppConstants.USER_TYPE.ADMIN || userType === AppConstants.USER_TYPE.SALES;
									const editButton = hasSalesPermission? <A href={"/order/"+props.value+"/settings"}><i className="fa fa-pencil-square" aria-hidden="true"></i></A>: null;
									return <span>{props.value} {editButton}</span>
								}
							}, 
							{Header: 'Ordered On', accessor: 'createdDate', width: 180,
								Cell: props => <DateComponent date={props.value} showTime={true} />
							},
							{Header: 'Info', accessor: 'productSizes', width: 280,
								Cell: function(props){ 
										const sizes = props.value;
										let sizeInfo = sizes.toString();
										let isCoupleProduct = false;

										const product = props.original.product;
										if(product) {
											isCoupleProduct = AppUtil.isCoupleProduct(product);
											const shortSizeStr = isCoupleProduct? true: false;
											sizeInfo = AppUtil.getOrderSizeString(props.original, product, shortSizeStr);
										}

										const totalCharge = <b>Rs. {AppUtil.formatNumber(props.original.totalCharge)} /- </b>;

										const isPaid = props.original.paid || false;
										return <div>
												{sizeInfo} = {totalCharge}
												{isPaid? <b style={{color: "#f8951b"}}>PAID</b>: ""}
												</div>;
									}
							}];

		return orderInfo;
	}

	getProductInfoColumn() {
		const userType = SessionStore.getCurrentSession()? SessionStore.getCurrentSession().user.userType: null;
		const isAdmin = userType === AppConstants.USER_TYPE.ADMIN;
		const productInfo = [{Header: 'Type', accessor: 'product', width: 100,
								Cell: props => {
									return AppConstants.PRODUCT_TYPES[props.value.productType].label;
								}},
							{Header: 'Product', accessor: 'product', width: 200,
								Cell: props => {
									const product = props.original.product;

									const isPublished = product.productState === AppConstants.PRODUCT_STATE['APPROVED'];
									const productTitle = AppUtil.getProductTitle(props.original.product);
									return (isAdmin || isPublished)? (<A href={AppUtil.getProductURL(props.value)}>{productTitle}</A>): <u>{productTitle}</u>;
								}
							}
							];

		return productInfo;
	}

	getOrderStateColumn() {
		let stateInfo = [{Header: 'Delivered On', accessor: 'deliveredDate', width: 140,
								Cell: props => props.value? <DateComponent date={props.value} />: '-'
							}];
		const userType = SessionStore.getCurrentSession()? SessionStore.getCurrentSession().user.userType: null;

		if(this.props.changeOrderState === true) {
			const orderStateChangeForm = {Header: 'Order State', accessor: 'orderState', width: 300,
										style: {overflow: 'visible'},
										Cell: rowData => {
											
											return <div>
												<div className="flexRow">
													<b>{ORDER_STATE[rowData.value].label}</b>

													{rowData.value === ORDER_STATE.DELIVERED.value && userType === AppConstants.USER_TYPE.ADMIN &&
														<Button style={{marginLeft: '10px', background: '#f8f8ff', padding: '5px', borderRadius: '5px', cursor: 'pointer'}}
														onClick={() => {
															this.setState({toUpdateOrder: rowData.original});
														}}>Close</Button>
													}

													{rowData.value !== ORDER_STATE.DELIVERED.value && rowData.value !== ORDER_STATE.DELIVERED_CLOSED.value &&
														<Button style={{marginLeft: '10px', background: '#f8f8ff', padding: '5px', borderRadius: '5px', cursor: 'pointer'}}
														onClick={() => {
															this.setState({toUpdateOrder: rowData.original});
														}}>Change State</Button>
													}
												</div>

												{
													rowData.value === ORDER_STATE.CANCELLED.value && rowData.original.cancelledReason &&
													<div>
														<br />
														- {rowData.original.cancelledReason}
													</div>

												}
											</div>
											
											
											
										}				
									};
			stateInfo.push(orderStateChangeForm);
		} else {
			
			const orderState = {Header: 'Order State', accessor: 'orderState', width: 200,
							Cell: rowData => {

								const orderLabel = rowData.value === ORDER_STATE.DELIVERED_CLOSED.value? ORDER_STATE.DELIVERED.label: ORDER_STATE[rowData.value].label;

								const cancelledReason = rowData.value === ORDER_STATE.CANCELLED.value && rowData.original.cancelledReason? rowData.original.cancelledReason: '';
								return <div><b>{orderLabel}</b>
									{cancelledReason &&
										<p>
											- {cancelledReason}
										</p>
									}
									</div>
							}};
			stateInfo.push(orderState);
		}

		return stateInfo;
	}


	handleCloseOrderModalClose() {
		this.setState({toUpdateOrder: null});
	}

	render() {
		const orders = this.props.orders;

		let columns = [{Header: 'Order Detail', columns: this.getOrderInfoColumn()}];

		if(this.props.showProductInfo === true)
			columns.push({Header: 'Product Detail', columns: this.getProductInfoColumn()});

		columns.push({Header: 'State Detail', columns: this.getOrderStateColumn()});
		
		let style = [];
		if(this.props.style) style.push(this.props.style);

		const showLoading = orders? false: true;

		let unpaidOrders = null;
		if(orders) {
			unpaidOrders = orders.filter(o => o.paid !== true && 
										(o.orderState === ORDER_STATE.ORDER_PLACED.value 
											|| o.orderState === ORDER_STATE.ORDER_CONFIRMED.value
											|| o.orderState === ORDER_STATE.SHIPPING.value)).toArray();
		}

		return <div style={style} id="orderList">
				{
					this.props.showPaymentOption &&
					<PaymentInfo unpaidOrders={unpaidOrders} />
				}

			<div className="flexRow" style={{margin: '10px 0', justifyContent: 'space-between', alignItems: 'baseline'}}>
				{this.props.title && 
					<h2>{this.props.title} <i className="fa fa-shopping-cart" aria-hidden="true"></i></h2>
				}

				
				
			</div>
			
			
			<ReactTable data={orders? orders.toArray(): []} columns={columns} minRows={5} 
						noDataText="No Orders Found." loading={showLoading} 
						SubComponent={OrderSubComponent} 
						className="-highlight" defaultPageSize={15} 
						  />

			{
				this.state.toUpdateOrder &&
				<ChangeOrderStateModalForm order={this.state.toUpdateOrder} 
									onClose={this.handleCloseOrderModalClose}
									stockOwners={this.props.stockOwners} />
			}
		</div>
	}
}


export default Radium(OrdersList);


// WEBPACK FOOTER //
// ./src/views/order/OrdersList.js